import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";

export default Lightbox;
